/**
 * Defaults de mapa — ÚLTIMO fallback (offline, error de red, config
 * malformada o ausente). La fuente primaria es la config por tenant
 * `map_default_center` (AppConfig.settings / catálogo FeatureFlag),
 * consumida vía useTenantMapCenter().
 */
export const DEFAULT_MAP_CENTER = { lat: 41.79, lng: 1.63 }; // Cataluña
export const DEFAULT_MAP_ZOOM = 8;

/** Key en AppConfig.settings / catálogo FeatureFlag. Valor: JSON string
 *  {"lat":Number,"lng":Number,"zoom":Number?}. */
export const MAP_DEFAULT_CENTER_KEY = 'map_default_center';
